import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';

import { isLogin, myRoles } from '../../../Redux/user-profile/selectors';
import { logout } from '../../../Redux/user-profile/actions';
import { toggleSideMenu } from '../../../Redux/side-menu/actions';
import { isSideMenuOpen } from '../../../Redux/side-menu/selectors';

import SideMenu from './SideMenu';

const filterMenu = (menus = [], isLogin = false, myRoles = []) =>
  menus.filter(
    menu =>
      menu.private !== true ||
      (isLogin &&
        menu.roles &&
        (menu.roles.length === 0 ||
          (menu.roles.length > 0 && menu.roles.some(role => myRoles.indexOf(role) >= 0)))),
  );

const MapperHOC = compose(
  withRouter,
  connect(
    state => ({
      isLogin: isLogin(state),
      myRoles: myRoles(state),
      isSideMenuOpen: isSideMenuOpen(state),
    }),
    { logout, toggleSideMenu },
    null,
    { pure: false },
  ),
  withProps(({ menus, isLogin, myRoles }) => ({
    rendermenus: filterMenu(menus, isLogin, myRoles) || [],
  })),
);

export default MapperHOC(SideMenu);
